module.exports = __webpack_public_path__ + "static/dmexco-logo-9229165e4a6dd9cd0fd2b39689bacf11.svg";